<form (ngSubmit)="onSubmit()">
  <h1>{{ 'NOT_FOUND.HEADER' | translate }}</h1>
  <p class="not-found-message" [translate]="'NOT_FOUND.MESSAGE'"></p>

  <div *ngIf="!loading">
    <div class="url-input-container">
      <p class="galabid-app-url">{{ appUrl }}</p>
      <input name="url_name" autofocus #urlNameElement [(ngModel)]="auction" required />
    </div>

    <button mat-button type="submit" mat-raised-button color="primary" class="submit">
      <span>
        {{ 'NOT_FOUND.SUBMIT' | translate }}
      </span>
    </button>
  </div>
  <div class="loader-container" *ngIf="loading">
    <mat-spinner [diameter]="60"> </mat-spinner>
  </div>
</form>
